import { StatusData } from '@oneethos/shared'
import { useState } from 'react'
import Amortization from './amortization'

type PaymentDetailsProps = {
  project: StatusData
}

export const PaymentDetails = ({ project }: PaymentDetailsProps) => {
  const [showAmortization, setShowAmortization] = useState(false)
  return <div>
    <h6>Payment Details</h6>
    {showAmortization
      ? <>
        <Amortization statusData={project} />
        <div className="alert alert-danger">
          This calculation assumes a Loan Date of today and may
          not match dates from original documents.
        </div>
      </>
      : <button type="button"
        className="btn btn-primary btn-sm"
        onClick={() => setShowAmortization(true)}>
        Calculate Payment Details
      </button>
    }
  </div>
}